import ObjectCopyService from "external-services/object-copy-service/index";
import AdminService from "external-services/diary-admin-service/admin.service";

// requiring html templates so that hot reloading works
const template = require('./guestList.html');
const NS = 'GuestListComponent'; // jshint ignore:line


export default {
  bindings: {
    booking: '=',
    customer: '<',
    forceValidation: '=',
    isValid: '=',
    isCompact: '<'
  },
  controllerAs: 'vm',
  template,
  controller
};

function controller($scope, unregister) {
  "ngInject";

  const vm = this;
  let listeners;

  vm.$onInit = () => {

    listeners = [];

    vm.hasWarningFirstGuestReplaced = null;
    vm.mainCustomerAdded = false;
    vm.warningRemovedItems = null;

    listeners.push($scope.$watch('vm.customer', val => {
      setMainCustomerAdded();
    }));

    listeners.push($scope.$watch('vm.booking.people', val => {
      if (val < vm.booking.customersCovid.length) {
        removeGuests(val);
      } else if (val > vm.booking.customersCovid.length) {
        addEmptyItems(vm.booking.customersCovid.length, vm.booking.people);
      }
    }));

    vm.venue = AdminService.getVenue();

    if (!vm.booking.customersCovid) {
      vm.booking.customersCovid = [];
    }

    if (!vm.booking.customersCovid.length) {
      addEmptyItems(0, vm.booking.people);
    }
  };


  vm.$onDestroy = () => {
    unregister(listeners);
  };


  vm.onContentChanged = function(isValid, index) {
    vm.booking.customersCovid[index].isValid = isValid;

    vm.isValid = vm.booking.customersCovid.every(val => val.isValid);
    setMainCustomerAdded();
  }

  function removeGuests(maxLength) {

    let removedItems = [];
    const amountToRemove = vm.booking.customersCovid.length - maxLength;

    const removeFromBottom = (doPhoneCheck) => {
      for (let i = vm.booking.customersCovid.length-1; i>=0; i--) {
        const item = vm.booking.customersCovid[i];

        if (removedItems.length < amountToRemove) {
          if (!doPhoneCheck || doPhoneCheck && !item.phoneNumber) {
            const removedItem = vm.booking.customersCovid.splice(i, 1)[0];
            removedItems.push(removedItem);
          }
        }
      }
    }

    removeFromBottom(true); // first removes only items that do not have a phone number

    // if there are still items to remove with phone numbers, then we remove them, but record them for a possible restore
    if (removedItems.length < amountToRemove) {
      removeFromBottom(false);
    }

    removedItems = removedItems.filter(o => !!o.phoneNumber);
    vm.warningRemovedItems = removedItems.length ? removedItems : null;
  }

  function setMainCustomerAdded() {
    const customerExists = vm.customer && vm.customer.phone && vm.booking.customersCovid.some(o => o.phoneNumber === vm.customer.phone);
    vm.mainCustomerAdded = customerExists;
  }

  // populates empty guestList based on how many covers (minus the main customer)
  function addEmptyItems(start, end) {
    for (let i=start; i<end; i++) {
      vm.booking.customersCovid.push({firstName: '', lastName: '', phoneNumber: '', isValid: true});
    }
  }

  vm.restoreFirstGuest = function() {
    vm.booking.customersCovid[0] = vm.hasWarningFirstGuestReplaced;
    vm.hasWarningFirstGuestReplaced = null;
  }

  vm.restoreRemovedGuests = function() {
    vm.booking.customersCovid = [
      ...vm.booking.customersCovid,
      ...vm.warningRemovedItems
    ];

    vm.booking.people += vm.warningRemovedItems.length;

    vm.warningRemovedItems = null;
  }

  vm.hasMain = function() {
    return vm.booking.customersCovid.some(o => o.isMain);
  }

  vm.addMainCustomer = function() {

    const firstEmpty = vm.booking.customersCovid.find(o => !o.phoneNumber);
    // if no empty slots, replaces the first customer
    if (!firstEmpty) {
      vm.hasWarningFirstGuestReplaced = ObjectCopyService.angularSafeCopy(vm.booking.customersCovid[0]);
      vm.booking.customersCovid[0].firstName = vm.customer.firstName;
      vm.booking.customersCovid[0].lastName = vm.customer.lastName;
      vm.booking.customersCovid[0].phoneNumber = vm.customer.phone;
      vm.forceValidation = true;
      setMainCustomerAdded();
      return;
    }

    firstEmpty.firstName = vm.customer.firstName;
    firstEmpty.lastName = vm.customer.lastName;
    firstEmpty.phoneNumber = vm.customer.phone;
    vm.forceValidation = true;
    setMainCustomerAdded();

    vm.hasWarningFirstGuestReplaced = null;
  }
}
